export enum openAiTypes {
  FETCH_OPENAI_REQUEST = "FETCH_OPENAI_REQUEST",
  FETCH_OPENAI_SUCCESS = "FETCH_OPENAI_SUCCESS",
  FETCH_OPENAI_FAILURE = "FETCH_OPENAI_FAILURE",
}